"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var size_1 = require("./controller/size");
var box_1 = require("./shape/box");
var Box = /** @class */ (function (_super) {
    tslib_1.__extends(Box, _super);
    function Box(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'box', shapeType: 'box', generatePoints: true }, cfg)) || this;
        // 初始化 sizeController
        var sizeController = new size_1.default(_this);
        _this.set('sizeController', sizeController);
        _this.set('shapeFactory', box_1.default);
        return _this;
    }
    Box.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        cfg.size = this.getNormalizedSize(obj);
        return cfg;
    };
    return Box;
}(base_1.default));
exports.default = Box;
//# sourceMappingURL=box.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/box.js
// module id = 801
// module chunks = 37